import { RangePickerProps as AntdRangePickerProps } from 'antd/lib/date-picker';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { StyledRangePicker } from './RangePicker.styles';
import { DATE_FORMAT_PATTERN, DateTime } from 'lib/utils/date-handling/DateTime';

type RangePickerProps = AntdRangePickerProps;

export const RangePicker = (props: RangePickerProps): JSX.Element => {
  const { i18n } = useTranslation();
  const { className, ...rest } = props;
  const rangePickerClassName = classnames('rangePicker', className);

  return (
    <StyledRangePicker
      getPopupContainer={(triggerNode): HTMLElement => triggerNode}
      className={rangePickerClassName}
      format={(date): string =>
        DateTime.formatDateByLocale(i18n.language, date.toISOString(), DATE_FORMAT_PATTERN.DATE)
      }
      separator={'-'}
      {...rest}
    />
  );
};
